export const PLINKO_WIDTH = 640;
export const plinkoGeometry = (rows) => {
  const gap = 568 / (rows + 1), top = 32;
  return { gap, step: gap, top, height: Math.ceil(top + (rows - 1) * gap + gap * .65) };
};
export const plinkoDuration = (rows) => .5 + rows * .07;
export const exactMultiplier = (e8) => (e8 / 1e8).toFixed(8).replace(/\.?0+$/, '');
export const shortMultiplier = (e8) => {
  const value = e8 / 1e8;
  return value >= 1000 ? `${Number((value / 1000).toFixed(1))}k` : Number(value.toFixed(value < 1 ? 2 : 1)).toString();
};
export const bucketChance = (rows, bucket) => {
  let combinations = 1;
  for (let i = 1; i <= bucket; i += 1) combinations = combinations * (rows - i + 1) / i;
  return combinations / 2 ** rows * 100;
};
export const plinkoTrajectory = (path) => {
  const { gap, step, top, height } = plinkoGeometry(path.length);
  const xs = [320], ys = [12], hits = [];
  let rights = 0;
  path.forEach((right, row) => {
    const x = 320 + (rights - row / 2) * gap, y = top + row * step - 10;
    xs.push(x); ys.push(y); hits.push({ y, key: `${row}-${rights + 1}` });
    const dx = (right ? 1 : -1) * gap / 2;
    xs.push(x + dx * .38, x + dx * .75);
    ys.push(y - 7, y + step * .4);
    rights += right;
  });
  xs.push(320 + (rights - path.length / 2) * gap); ys.push(height);
  return { xs, ys, hits, times: xs.map((_, index) => index / (xs.length - 1)) };
};